interface StatusTabItem {
  key: string;
  label: string;
  value: number;
}

interface StatusTabsProps {
  tabs: StatusTabItem[];
  active: string;
  onChange: (key: string) => void;
}

export default function StatusTabs({ tabs, active, onChange }: StatusTabsProps) {
  return (
    <div className="flex gap-1 overflow-x-auto rounded-[10px] border border-line bg-white p-1 shadow-card">
      {tabs.map((t) => {
        const isActive = t.key === active;
        return (
          <button
            key={t.key}
            type="button"
            onClick={() => onChange(t.key)}
            className={`flex shrink-0 items-center gap-2 whitespace-nowrap rounded-lg px-3.5 py-2 text-sm font-medium transition-colors cursor-pointer ${
              isActive ? "bg-primary-500 text-white" : "text-ink-secondary hover:bg-page hover:text-ink"
            }`}
          >
            {t.label}
            <span
              className={`rounded-full px-2 py-0.5 text-xs font-semibold ${
                isActive ? "bg-white text-primary-500" : "bg-[#F1F5F9] text-ink-secondary"
              }`}
            >
              {t.value}
            </span>
          </button>
        );
      })}
    </div>
  );
}